import { Route } from '@angular/router';
import { authGuard, publicGuard } from '@/auth-portal-lib';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@/auth-portal-lib').then((m) => m.LoginComponent),
    canActivate: [publicGuard],
  },
  {
    path: 'register',
    loadComponent: () =>
      import('@/auth-portal-lib').then((m) => m.RegisterComponent),
    canActivate: [publicGuard],
  },
  {
    path: 'switchboard',
    loadComponent: () =>
      import('@/auth-portal-lib').then((m) => m.SwitchboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'force-password-reset',
    loadComponent: () =>
      import('@/auth-portal-lib').then((m) => m.ForcePasswordResetComponent),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('@/auth-portal-lib').then((m) => m.UserProfileComponent),
    canActivate: [authGuard],
  },

  {
    path: '**',
    redirectTo: '/login',
  },
];
